<template lang="pug">
  .flex.justify-center.px-5.sm-px-0
    a.flex-1.flex-grow.sm-flex-none.block.mx-10.btn-theme-outlined(v-if="account", :href="myAccountUrl")
      btn.sm-min-w-btn.truncate(theme="inherit") My Account
    a.flex-1.flex-grow.sm-flex-none.block.mx-10.btn-theme-outlined(v-for="link in links", :href="link.url", target="_blank", rel="noopener")
      btn.sm-min-w-btn(theme="inherit") {{link.label}}
    button.social-btns__mail.flex-1.flex-grow.sm-flex-none.mx-10.btn-theme-outlined(@click="subscribe(true)")
      btn.sm-min-w-btn.whitespace-no-wrap(theme="inherit") Mailing List
</template>

<script>
import { mapMutations } from 'vuex'
import _get from 'lodash/get'
import Btn from '@/components/Btn'
export default {
  name: 'SocialBtns',
  props: {
    account: { type: Boolean, default: false }
  },
  components: { Btn },
  computed: {
    links () {
      return _get(this.$store.state.site, 'social_media_links') || []
    },
    myAccountUrl () {
      return 'http://' + process.env.VUE_APP_SHOPIFY_DOMAIN + '/account'
    }
  },
  methods: {
    ...mapMutations({ subscribe: 'SET_SUBSCRIBE' })
  }
}
</script>

<style>
</style>
